export const fetchSession = async (scenarioId: string, isAssessment: boolean) => {
	const currentSession = await fetch('/api/sessions', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ scenarioId, isAssessment }),
	});

	return currentSession;
};
